import { Injectable, Injector } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { AppSettings } from '@app/common/app-setting';
import {HttpClient} from '@angular/common/http';
import { AutharizedEndPointService } from '@app/services/base-service/autharized-endpoint.service';
import { CustomerStatementModel } from '@app/models/customer-statement/CustomerStatementModel';

@Injectable()
export class CustomerStatementEndpoint extends AutharizedEndPointService{
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getCustomerStatementUrl: string = 'api/CustomerReportManagement/CustomerSaleStatement/';
    private readonly _getBillPurchaseAndPaymentSummaryUrl: string = 'api/MerchantDashboardReport/GetBillPurchaseAndPaymentSummary/';

    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }

    getUrl(url: string) {
        return this._baseurl + url;
    }
    getCustomerStatement(CustomerId:number) {
        return this.http1.get(this.getUrl(this._getCustomerStatementUrl+CustomerId),this.AddAuthToken());
    }

    getBillPurchaseAndPaymentSummary(CustomerId:number) {
        return this.http1.get(this.getUrl(this._getBillPurchaseAndPaymentSummaryUrl+CustomerId),this.AddAuthToken());
    }

}


// WEBPACK FOOTER //
// ./src/app/services/customerStatement/customerStatement-endpoint.service.ts